"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsherProgramConfiguration = {
    CA: {
        programTitle: "PROGRAM NAME HERE"
    },
    NV: {
        programTitle: "Program Information:"
    },
    TX: {
        programTitle: "Program Title:"
    },
    TX2: {
        programTitle: "Program Title:"
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXNoZXJQcm9ncmFtLmNvbmZpZ3VyYXRpb24uanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9Db21tb24vcGFydHMvQXNoZXJQcm9ncmFtL0FzaGVyUHJvZ3JhbS5jb25maWd1cmF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQWEsUUFBQSx5QkFBeUIsR0FBRztJQUNyQyxFQUFFLEVBQUU7UUFDQSxZQUFZLEVBQUUsbUJBQW1CO0tBQ3BDO0lBQ0QsRUFBRSxFQUFFO1FBQ0EsWUFBWSxFQUFFLHNCQUFzQjtLQUN2QztJQUNELEVBQUUsRUFBRTtRQUNBLFlBQVksRUFBRSxnQkFBZ0I7S0FDakM7SUFDRCxHQUFHLEVBQUU7UUFDRCxZQUFZLEVBQUUsZ0JBQWdCO0tBQ2pDO0NBQ0osQ0FBQSJ9